<template>
	<svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="21.5" cy="21.5" r="19.5" stroke="#0096D6" stroke-width="4" />
		<path d="M13.0186 20.3356L19.2605 26.5775L29.6637 16.1743" stroke="#0096D6" stroke-width="4" />
	</svg>
</template>

<script>
	export default {
		name: 'Tick'
	};
</script>

<style scoped>
	svg {
		width: 3.5vw;
		max-width: 43px;
	}
</style>
